export enum OfflineDownloadTypeEnum {
  ALL = "All",
  PDF = "Pdf",
  PRESENTATION = "Presentation",
  IMAGE = "Image",
}

export enum OfflineDownloadSortOptionEnum {
  DOWNLOAD_DATE = "DownloadedOn",
  SIZE = "TotalSizeBytes",
}

export enum OfflineDownloadStatusEnum {
  DOWNLOADING = "Downloading",
  COMPLETED = "Completed",
  FAILED = "Failed",
}
